<template>
  <el-row>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; height: 24rem; padding-top: 5rem; background: url('../../../static/images/BIM_bg.png') center bottom / 120%">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 1108px">
          <div style="display: flex; justify-content: center; align-items: flex-start; flex-flow: column">
            <el-image src="../../../static/images/BIMIssueTrack/BIMIssueTrack_logo.png" style="height: 2.5rem"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 1rem; font-weight: 700; color: #0b4070; margin: 1rem 0 1.5rem">
              <span>改善沟通效率</span>
              <span style="display: inline-block; width: 1px; background: rgba(0,0,0,0.33); height: 1.3125rem; margin: 0 0.75rem"></span>
              <span>降低交互成本</span>
              <span style="display: inline-block; width: 1px; background: rgba(0,0,0,0.33); height: 1.3125rem; margin: 0 0.75rem"></span>
              <span>提高交付质量</span>
            </div>
            <el-link :underline="false" href="http://bimissue.alphabim.net/" target="_blank">
              <el-button type="primary" style="background: linear-gradient(90deg,#00bfff 4%, #296dcc); border-radius: 4px; border: none !important;">立即试用</el-button>
            </el-link>
          </div>
          <el-image src="../../../static/images/BIMIssueTrack/BIMQuestion.png" style="height: 15rem"></el-image>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; padding-top: 5rem; flex-flow: column">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 1108px; flex-wrap: nowrap">
          <div>
            <div style="display: flex; justify-content: center; align-items: center">
              <el-image style="width: 13rem; height: 13rem"
                        src="../../../static/images/BIMIssueTrack/BIMIssueTrack_1.png"
                        fit="cover"></el-image>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; font-size: 1.25rem; color: #222; font-weight: 700; margin: 1rem 0">
              全生命周期管理
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 14px; color: #666; font-weight: 400; line-height: 1.5rem; width: 15rem; text-align: left">
              覆盖BIM问题的创建、修改、回复、审核到销项完成的全生命周期，精细化管控每一个问题；确保BIM问题的集中管控，改善沟通效率。
            </div>
          </div>
          <div>
            <div style="display: flex; justify-content: center; align-items: center">
              <el-image style="width: 13rem; height: 13rem"
                        src="../../../static/images/BIMIssueTrack/BIMIssueTrack_2.png"
                        fit="cover"></el-image>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; font-size: 1.25rem; color: #222; font-weight: 700; margin: 1rem 0">
              与模型、图纸联动
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 14px; color: #666; font-weight: 400; line-height: 1.5rem; width: 15rem; text-align: left">
              与Revit、AutoCAD无缝集成，通过BIM问题整合其在BIM模型和图纸上发现的问题点，便于用户在设计工具中快速定位问题，并做出反馈，进行协同工作，降低交互成本。
            </div>
          </div>
          <div>
            <div style="display: flex; justify-content: center; align-items: center">
              <el-image style="width: 13rem; height: 13rem"
                        src="../../../static/images/BIMIssueTrack/BIMIssueTrack_3.png"
                        fit="cover"></el-image>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; font-size: 1.25rem; color: #222; font-weight: 700; margin: 1rem 0">
              实时统计与汇总
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 14px; color: #666; font-weight: 400; line-height: 1.5rem; width: 15rem; text-align: left">
              针对项目进行实时统计和汇总，便于协同各方了解项目情况，展示协同各方的工作成果，提高BIM成果交付质量。<br />
              支持按照项目要求定制问题报告模板！
            </div>
          </div>
        </div>
        <div style="margin: 7rem 0; display: flex; justify-content: center; align-items: center">
          <span style="display: inline-block; width: 12rem; height: 2px; background: linear-gradient(90deg,rgba(255,255,255,0), #bababa)"></span>
          <span style="margin: 0 2rem; font-size: 1rem; font-weight: 700; color: #888">功能简介</span>
          <span style="display: inline-block; width: 12rem; height: 2px; background: linear-gradient(to left, rgba(255,255,255,0), #bababa)"></span>
        </div>
        <div style="display: flex; justify-content: center; align-items: center; flex-flow: column">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8rem; width: 1108px">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 17rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">创建问题</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                通过问题管理AutoCAD和Revit客户端，记录问题视点及视点图片说明，便于汇总和管理。
              </div>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; width: 44rem; height: 29rem">
              <video class="video-js vjs-big-play-centered" controls data-setup="{}" preload="auto" style="width: 100%; height: 100%">
                <source src="http://bimissue.alphabim.net/Demo/video/1.mp4"></source>
              </video>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8rem; width: 1108px">
            <div style="display: flex; justify-content: center; align-items: center; width: 44rem; height: 29rem">
              <video class="video-js vjs-big-play-centered" controls data-setup="{}" preload="auto" style="width: 100%; height: 100%">
                <source src="http://bimissue.alphabim.net/Demo/video/2.mp4"></source>
              </video>
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 17rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">问题定位</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                通过问题管理AutoCAD和Revit客户端，在相应的图纸和模型中快速定位问题点，提高查找效率。
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8rem; width: 1108px">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 17rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">查看及回复</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                通过问题列表快速过滤和查看问题，支持回复和评论，实现多方协同和问题闭环管理。
              </div>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; width: 44rem; height: 29rem">
              <video class="video-js vjs-big-play-centered" controls data-setup="{}" preload="auto" style="width: 100%; height: 100%">
                <source src="http://bimissue.alphabim.net/Demo/video/3.mp4"></source>
              </video>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8rem; width: 1108px">
            <div style="display: flex; justify-content: center; align-items: center; width: 44rem; height: 29rem">
              <video class="video-js vjs-big-play-centered" controls data-setup="{}" preload="auto" style="width: 100%; height: 100%">
                <source src="http://bimissue.alphabim.net/Demo/video/4.mp4"></source>
              </video>
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 17rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">生成及查看报告</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                将问题批量导出到问题报告，通过问题报告查看和管理问题，实现现有BIM咨询业务的闭环管理。<br />
                支持按照项目要求定制问题报告模板！
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
    export default {
        name: "BIMIssueTrack",
        data: function () {
          return {
          }
        },
        components: {

        },
        created() {
        },
        mounted() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        methods: {

        }
    }
</script>

<style scoped>
  .el-main > .el-row {
    min-width: 1108px;
  }

  .el-row /deep/ .video-js {
    border-radius: 0.5rem;
    overflow: hidden;
  }

  .el-row /deep/ .vjs-big-play-centered .vjs-big-play-button {
    background: url('../../../static/images/BIMIssueTrack/BIMIssueTrack_start.png') center bottom no-repeat;
    width: 6rem;
    height: 6rem;
    top: calc(50% - 2rem);
    border: none;
    border-radius: 50%;
  }

  .el-row /deep/ .vjs-big-play-button .vjs-icon-placeholder {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/BIMIssueTrack.vue